import apiUseCases from "../api";
import store from "@src/reducers/store";

export interface GetEventsForSourceResult {
  success: boolean;
  data?: unknown;
  error?: string;
  status?: number;
}

export interface GetEventsForSourceParams {
  source: string;
  eventType: string;
  size?: number;
  from?: string;
  to?: string;
}

export const getEventsForSourceUseCase = async ({
  source,
  eventType,
  size,
  from,
  to,
}: GetEventsForSourceParams): Promise<GetEventsForSourceResult> => {
  const namespace = store.getState().yourSlice.authContext.customerNamespace;

  const response = await apiUseCases.getEventsForSourceAPI({
    namespace,
    source,
    eventType,
    size,
    from,
    to,
  });

  if (!response.success) {
    return {
      success: false,
      error: response.error,
      status: response.status,
    };
  }

  return {
    success: true,
    data: response.data,
  };
};
